import React, { useEffect, useState } from 'react'
import logoSC from "../../Imagenes/logoSCTKD.webp"

import { Typography, Button, Paper } from '@material-ui/core';
import { useNavigate } from "react-router"
import { makeStyles } from '@material-ui/styles';

import { useLocation } from 'react-router-dom';
import { CircularProgress } from '@mui/material';
import Carousel from 'react-material-ui-carousel'
import moment from 'moment/moment';

const Styles = makeStyles({

    backBtn: {
        display: "block",
        width: "100%",
        maxWidth: 360,
        margin: "0 auto 16px auto",
        padding: "14px 24px",
        borderRadius: 12,
        textTransform: "uppercase",
        fontWeight: 700,
        fontSize: 15,
        color: "#ffffff",
        letterSpacing: 1,
        background: "linear-gradient(180deg, #990000 0%, #660000 100%)",
        border: "1px solid rgba(255, 0, 0, 0.3)",
        boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.4)",
        cursor: "pointer",
        transition: "transform 0.2s ease, filter 0.2s ease",
        outline: "none",
        "&:active": {
            transform: "scale(0.98)",
            filter: "brightness(1.2)"
        }
    },
    card: {
        width: "100%",
        maxWidth: 360,
        margin: "0 auto",
        backgroundColor: "rgba(20, 24, 33, 0.65)",
        border: "1px solid rgba(255, 255, 255, 0.12)",
        borderRadius: 16,
        padding: 16,
        backdropFilter: "blur(12px)",
        WebkitBackdropFilter: "blur(12px)",
        boxShadow: "0 8px 32px 0 rgba(0, 0, 0, 0.37)",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        alignItems: "center"
    },
    cardTitle: {
        width: "100%",
        color: "#ffffff",
        fontWeight: 800,
        fontStyle: "italic",
        textTransform: "uppercase",
        letterSpacing: 1,
        fontSize: 18,
        textAlign: "center",
        textShadow: "2px 2px 6px rgba(0, 0, 0, 0.9)",
        borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
        paddingBottom: 10,
        marginBottom: 12
    },
    rondaTitulo: {
        width: "100%",
        color: "#ffffff",
        fontWeight: 800,
        fontStyle: "italic",
        textTransform: "uppercase",
        letterSpacing: 1,
        fontSize: 16,
        textAlign: "center",
        margin: "16px 0 4px 0",
        textShadow: "2px 2px 6px rgba(0, 0, 0, 0.9)"
    },
    matchRow: {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        gap: 6,
        padding: "12px 0",
        borderBottom: "1px solid rgba(255, 255, 255, 0.06)"
    },
    competidor: {
        width: "100%",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "8px 12px",
        boxSizing: "border-box",
        borderRadius: 8,
        border: "1px solid rgba(255, 255, 255, 0.1)",
        backgroundColor: "rgba(255, 255, 255, 0.03)"
    },
    competidorGanador: {
        border: "1px solid rgba(57, 255, 20, 0.5)",
        backgroundColor: "rgba(57, 255, 20, 0.1)"
    },
    competidorDestacado: {
        boxShadow: "0 0 0 1px rgba(57, 255, 20, 0.6)"
    },
    competidorLibre: {
        color: "#a0aec0",
        border: "1px dashed rgba(255, 255, 255, 0.15)"
    },
    nombre: {
        color: "#ffffff",
        fontSize: 14,
        fontWeight: 600,
        textTransform: "capitalize",
        flex: 1,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    },
    puntos: {
        color: "#39ff14",
        fontSize: 13,
        fontWeight: 700,
        marginLeft: 8,
        flexShrink: 0,
        textShadow: "0 0 8px rgba(57, 255, 20, 0.5)"
    },
    versus: {
        width: "100%",
        textAlign: "center",
        color: "#b3b3b3",
        fontSize: 12,
        fontWeight: 700,
        letterSpacing: 1,
        textTransform: "uppercase"
    },
    versusEmpate: {
        color: "#ffb347"
    }
})

const Grupos = ({ llave, compId }) => {

    const classes = Styles()
    const { state } = useLocation();
    const navigate = useNavigate()
    const [Encuentros, setEncuentros] = useState([]);
    const [categorias, setCategorias] = useState([]);
    const [anio, setAnio] = useState("2020");
    const [cantDias, setCantDias] = useState(1);
    const [loading, setLoading] = useState(true);

    useEffect(() => {

    }, [])



    const TipoCompe = (x) => {

        let data = x[0].disciplina_id
        let resu = "N/C"
        if (data == 1) { resu = "FORMAS" }
        if (data == 2) { resu = "LUCHA LIBRE" }
        if (data == 3) { resu = "ROTURA de POTENCIA" }
        if (data == 4) { resu = "SALTO" }

        return resu

    }

    const puntosTexto = (res) => {
        if (res == 1) return "60 pts."
        if (res == 0) return "40 pts."
        if (res == 2) return "50 pts."
        return "00 pts."
    }

    const competidorRow = (c, res, key) => {
        const libre = !c?.nombre
        const ganador = c?.resultado >= 1
        const destacado = compId != null && c?.competidor_id == compId

        return (
            <div
                key={key}
                className={[
                    classes.competidor,
                    libre ? classes.competidorLibre : "",
                    !libre && ganador ? classes.competidorGanador : "",
                    destacado ? classes.competidorDestacado : ""
                ].join(" ")}
            >
                <Typography className={classes.nombre}>
                    {libre ? "Competidor Libre" : c.nombre + " " + c.apellido}
                </Typography>
                {!libre ? <span className={classes.puntos}>{puntosTexto(res)}</span> : null}
            </div>
        )
    }

    const grupos = (l) => {
        let grupo = []

        let m = l.sort((a, b) => b.match_id - a.match_id)
        let cantMatch = m[0].match_id

        for (let index = 1; index <= cantMatch; index++) {

            let r = l.filter((x) => x.match_id == index)


            if (index == 1) {

                grupo.push(
                    <Typography key={`r1-${index}`} className={classes.rondaTitulo}>Ronda 1</Typography>)
            }

            if (index == (cantMatch / 2) + 1) {

                grupo.push(
                    <Typography key={`r2-${index}`} className={classes.rondaTitulo}>Ronda 2</Typography>)
            }

            const empate = r[0]?.resultado == 2 || r[1]?.resultado == 2

            grupo.push(
                <div key={`match-${index}`} className={classes.matchRow}>
                    {competidorRow(r[0], r[0]?.resultado, `a-${index}`)}
                    <span className={`${classes.versus} ${empate ? classes.versusEmpate : ""}`}>
                        {empate ? "Empate" : "VS"}
                    </span>
                    {competidorRow(r[1], r[1]?.resultado, `b-${index}`)}
                </div>
            )


        }




        return (grupo)
    }

    return (

        <div style={{ height: "auto", width: "100%", color: "white" }}  >

            <Button className={classes.backBtn} onClick={() => navigate(-1)}>
                Volver
            </Button>

            {llave.length > 0 ?
                <div className={classes.card}>
                    <Typography className={classes.cardTitle}>Encuentros</Typography>
                    {grupos(llave)}
                </div>


                : <>
                    <CircularProgress style={{ color: "#39ff14" }} />
                </>
            }


        </div>
    );
}

export default Grupos;
